<template>
    <div>
        <div class="row">
            <div class="col-xs-12 col-md-6">
                <h5 class="bold">Resultados de la simulación de pago.</h5>
                <h5 v-if="simulationMade"><small>Si estas de acuerdo con los resultados presiona el boton "Reducir", y confirma la operación<br>de lo contrario modifica las cantidades en la sección de "Adeudos".</small></h5>
                <vs-button :disabled="!(simulationMade && dataResponse.availableMoney!= dataResponse.newAvailableMoney)" @click="confirmarReducir" color="success" class="mb-5">Reducir</vs-button>
            </div>
            <div v-if="simulationMade" class="col-xs-12 col-md-3">
                <h5 class="bold">Antes del pago:</h5>
                <h5><small>Dinero disponible: <strong style="color:green">{{costFormat(dataResponse.availableMoney)}}</strong></small></h5>
                <h5><small>Adeudo contemplado: <strong style="color:red">{{costFormat(dataResponse.dueAmount)}}</strong></small></h5>
                <h5 v-if="dataResponse.needBalanceAdjust"><small>Ajuste para cubrir mensualidad (C155): <strong style="color:green">+{{costFormat(dataResponse.newDueAmount)}}</strong></small></h5>
                <h5><small>Adeudo total: <strong style="color:red">{{costFormat(dataResponse.totalDue)}}</strong></small></h5>
            </div>
            <div v-if="simulationMade" class="col-xs-12 col-md-3">
                <h5 class="bold">Después del pago:</h5>
                <h5><small>Dinero disponible: <strong style="color:green">{{costFormat(dataResponse.newAvailableMoney)}}</strong></small></h5>
                <h5><small>Adeudo restante: <strong style="color:red">{{costFormat(dataResponse.newDueAmount)}}</strong></small></h5>
                <h5 v-if="dataResponse.needBalanceAdjust"><small>Ajuste por cubrir mensualidad (C255): <strong style="color:red">-{{costFormat(dataResponse.newDueAmount)}}</strong></small></h5>
                <h5><small>Adeudo total: <strong style="color:red">{{costFormat(dataResponse.newTotalDue)}}</strong></small></h5>
            </div>
        </div>
        <div v-if="simulationMade">
            <br>
            <div v-if="dataResponse.currentDues.length>0">
                <p style="text-align:center; color:black;"><strong>Adeudos actuales:</strong></p>
                <div class="row">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead class="thead-dark">
                            <th :key="indextr" v-for="(column, indextr) in columns" :data="column">
                                {{column.title}}
                            </th>
                            </thead>
                            <tbody>
                            <tr :key="indextr" v-for="(due, indextr) in dataResponse.currentDues" :data="due">
                                <td>{{ compactDateFormat(due.payment_date)}}</td>
                                <td class="table-number">{{costFormat(due.due, 2)}}</td>
                                <td class="table-number">{{costFormat(due.amortization, 2)}}</td>
                                <td class="table-number">{{costFormat(due.interest, 2)}}</td>
                                <td class="table-number">{{costFormat(due.tax, 2)}}</td>
                                <td class="table-number">{{costFormat(due.penalty, 2)}}</td>
                                <td class="table-number">{{costFormat(due.penalty_tax, 2)}}</td>
                                <td class="table-number">{{costFormat(due.moratorium_interest, 2)}}</td>
                                <td class="table-number">{{costFormat(due.moratorium_interest_tax, 2)}}</td>
                                <td class="table-number">{{costFormat(due.client_comission, 2)}}</td>
                                <td class="table-number">{{costFormat(due.client_comission_tax, 2)}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="dataResponse.newDues.length>0">
                <br>
                <p style="text-align:center; color:black;"><strong>Adeudos que cambiarán después del pago:</strong></p>
                <div class="row">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                            <th style="background:#43a047; color:white" :key="indextr" v-for="(column, indextr) in columns" :data="column">
                                {{column.title}}
                            </th>
                            </thead>
                            <tbody>
                            <tr :key="indextr" v-for="(due, indextr) in dataResponse.newDues" :data="due">
                                <td>{{ compactDateFormat(due.payment_date)}}</td>
                                <td class="table-number">{{costFormat(due.due, 2)}}</td>
                                <td class="table-number">{{costFormat(due.amortization, 2)}}</td>
                                <td class="table-number">{{costFormat(due.interest, 2)}}</td>
                                <td class="table-number">{{costFormat(due.tax, 2)}}</td>
                                <td class="table-number">{{costFormat(due.penalty, 2)}}</td>
                                <td class="table-number">{{costFormat(due.penalty_tax, 2)}}</td>
                                <td class="table-number">{{costFormat(due.moratorium_interest, 2)}}</td>
                                <td class="table-number">{{costFormat(due.moratorium_interest_tax, 2)}}</td>
                                <td class="table-number">{{costFormat(due.client_comission, 2)}}</td>
                                <td class="table-number">{{costFormat(due.client_comission_tax, 2)}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="dataResponse.initialPaymentsCovered.length>0">
                <br>
                <p style="text-align:center; color:black;"><strong>Pagos iniciales cubiertos con el pago:</strong></p>
                <div class="row">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <caption></caption>
                            <thead>
                                <th style="background:#303f9f; color:white" scope="col">PID</th>
                                <th style="background:#303f9f; color:white" scope="col">PROYECTO</th>
                                <th style="background:#303f9f; color:white" scope="col">MONTO DE PAGO INICIAL</th>
                            </thead>
                            <tbody>
                            <tr :key="indextr" v-for="(payment, indextr) in dataResponse.initialPaymentsCovered" :data="payment">
                                <td class="table-number">{{payment.project_id}}</td>
                                <td class="table-number">{{payment.alias}}</td>
                                <td class="table-number">{{costFormat(payment.amount, 2)}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dateHelper from "@mixins/dateHelper";
    import formatHelper from "@mixins/formatHelper";
    const columnsDefinition = [
      { title: "Mes"},
      { title: "Adeudo"},
      { title: "Amortización"},
      { title: "Interés"},
      { title: "IVA"},
      { title: "Penalización"},
      { title: "IVA penalización"},
      { title: "Intereses moratorios"},
      { title: "IVA intereses moratorios"},
      { title: "Comisión"},
      { title: "IVA comisión"},
    ];
    export default {
        name: "ResumeReduce",
        props:['client_id'],
        mixins: [formatHelper,dateHelper],
        data(){
            return {
              columns: columnsDefinition,
              loading:false,
              dataResponse: {
                  currentDues :[],
                  newDues :[],
                  initialPaymentsCovered :[],
                  availableMoney: 0,
                  newAvailableMoney: 0,
                  newDueAmount: 0,
                  needBalanceAdjust: false
              },
              simulationMade: false
            }
        },
        methods: {
            reset(){
                if (this.simulationMade) {
                    this.simulationMade = false;
                }
            },
            async simulate(){
                this.showLoading(true);
                this.simulationMade = false;
                await axios.post('/api/cobranza/adeudo/simularPago', {
                    client_id: this.client_id
                }).then(response => {
                    this.dataResponse = response.data;
                    this.simulationMade = true;
                    this.successNotif("Aviso", 'Simulación de pago exitosa.', 4000);
                }).catch(error => {
                    this.simulationMade = false;
                    if(error.response.data.message !== undefined){
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    }else{
                        this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                    }
                });
                this.showLoading(false);
            },
            confirmarReducir(){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `¿Continuar con esta operación?`,
                    text: 'Esto reducira los adeudos primero y después los pagos iniciales pendientes que alcancen a ser cubiertos.',
                    acceptText: "Confirmar",
                    cancelText: "Cancelar",
                    accept: this.pagarAdeudos
                })
            },
            async pagarAdeudos(){
                this.showLoading(true);
                await axios.post('/api/cobranza/adeudo/pagar', {
                    client_id: this.client_id,
                    needBalanceAdjust: this.dataResponse.needBalanceAdjust,
                    amountToAdjust: this.dataResponse.newDueAmount,
                }).then(response => {
                    this.$emit('updated', 1)
                    this.simulationMade = false;
                    this.successNotif("Aviso", 'Operación exitosa, dispersión en proceso.', 4000);
                }).catch(error => {
                    if(error.response.data.message !== undefined){
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    }else{
                        this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                    }
                });
                this.showLoading(false);
            }
        }
    }
</script>

<style scoped>
    td > input{
        max-width: 100px;
        border:none;
    }
    td, th
    {
        text-align: center; 
        vertical-align: middle;
    }
</style>